var Utils = require("common/Utils");

/*
 * Util functions user attributes
 */
function AttributesUIHelper() {
    /**
     * Creates UI elements for the given attribute. The new UI elements are based on a format of the attribute (checkbox, password, text, ...).
     * The elements are added to the given field contained.
     * A separated label UI element can be created for the attribute.
     */
    this.createAttributeUI = function(attribute, $fieldContainer, labelElemVisible, namespace) {
        // If the namespace used is session, then the label should be replaced by the internationalised string.
        // The description should also be replaced by the internationalised string.
        if (namespace === "session") {
            attribute.description = Utils.getAuthSchemeDisplayLabel(attribute.label, attribute.description);
            attribute.label = Utils.getAuthSchemeDisplayLabel(attribute.label, attribute.label);
        }

        // If a separated label element should be created -> an attribute description will be used as an input field placeholder.
        // The attribute label should be used as the placeholder otherwise.
        var placeholder = labelElemVisible ? attribute.description : attribute.label;

        if (labelElemVisible) {
            $fieldContainer.append(_createAttributeLabelUI(attribute));
        }

        switch (attribute.format) {
            case 4: { // Password
                $fieldContainer.append($("<input>", {type : "password", name : attribute.id, placeholder : placeholder, value : attribute.value}));
                break;
            }
            default: { // Default to text
                $fieldContainer.append($("<input>", {type : "text", name : attribute.id,  placeholder : placeholder, value : attribute.value,
                    autocomplete : "off", autocorrect : "off", autocapitalize : "off", spellcheck : "false", "accept-charset" : "UTF-8"}));
                break;
            }
        }
    };

    function _createAttributeLabelUI(attribute) {
        return $("<label>", {text : attribute.label, "for" : attribute.id});
    }

    this.enhanceAttributesFormItems = function($attrList, submitFunction, inputFieldAsParam) {
        // Allow submitting of an user attributes form by pressing Enter (or a mobile phone equivalent) in a text field
        $attrList.find("input[type='text'], input[type='number'], input[type='password']").each(function() {
            var $input = $(this);
            var param;

            if (inputFieldAsParam) {
                param = $input;
            }
            Utils.unregisterKeyboardSubmit($input);
            Utils.registerKeyboardSubmit($input, submitFunction, param);
        });
        $attrList.find("input[type='checkbox']").checkboxradio();
        $attrList.find("input[type='text'], input[type='number'], input[type='password'], textarea").textinput();
        $attrList.find("input[type='password']").attr("autocomplete", "off");
    };
}

module.exports = new AttributesUIHelper();


//////////////////
// WEBPACK FOOTER
// ./attributes/AttributesUIHelper.js
// module id = 52
// module chunks = 3 4